export default __webpack_public_path__ + "static/media/cisspbadge.ccb54b52.png";